import React from 'react'
import { Box, Typography, Button, IconButton } from "@mui/material";
import { AccessTime, Check } from '@mui/icons-material';
export const VerificationSuccess = () => {
    return (
        <div
            style={{
                // width: '400px',
                // height: '300px',
                background: 'linear-gradient(180deg, #E6FFE6 0%, #F6FFF6 100%)',

                borderRadius: '16px',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
                position: 'relative',
            }}
        >
            {/* Icon */}
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    background: 'linear-gradient(180deg, #65A76540 0%, #65A76540 100%)',
                    borderRadius: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <Check
                    sx={{ fontSize: 40, color: '#FFF' }}
                />
            </Box>

            {/* Title */}
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    color: '#4F4F4F',
                    marginTop: 2,
                }}
            >
                Verification Successfull
            </Typography>

            {/* Description */}
            <Typography
                variant="body2"
                sx={{
                    color: '#828282',
                    textAlign: 'center',
                    marginTop: 1,
                }}
            >
              Congratulations, your details have been verified. You can now enjoy all features.
            </Typography>


        </div>
    )
}
